import { parseDbml } from '@hyphen-db-studio/dbml-parser';
import type { Schema } from '@hyphen-db-studio/schema-core';

export interface ImportResult {
  dbmlSource: string;
  schema: Schema;
  errors: { message: string; line: number }[];
}

/**
 * v1 import: accepts .dbml directly, and best-effort treats .sql as already-DBML-like text
 * (SQL/Prisma/MySQL/SQLite importers are Milestone 3 per the product spec).
 */
export function importSchemaFromText(source: string): ImportResult {
  const { schema, errors } = parseDbml(source);
  return { dbmlSource: source, schema, errors };
}

export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ''));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
}
